import React from "react";
import {Button, Toast} from "spectre-react/dist/cjs";


const ModalContainerError = ({error, close}) => {
    return (
        <div className="modal-container">
            <div className="modal-header">
                <span className="btn btn-clear float-right" onClick={close}/>
                <div className="modal-title h5">Ошибка</div>
            </div>
            <div className="modal-body">
                <Toast>{error}</Toast>
            </div>
            <div className="modal-footer">
                <Button link onClick={close}>Закрыть</Button>
            </div>
        </div>
    );
};

export default ModalContainerError;